<template>
  <section>
    <b-table hover :fields="fields" :items="items"></b-table>
  </section>
</template>

<script>
import Vue from 'vue'

import { TablePlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

Vue.use(TablePlugin)

export default {
  i18n,
  name: 'size-cm-conversion-table',
  data() {
    return {
      items: [
        { format: '16K', centimeter: '26x19' },
        { format: '18K', centimeter: '23x17' },
        { format: '25K', centimeter: '20.8x14.8' },
        { format: '28K', centimeter: '26x11' },
        { format: '32K', centimeter: '18.7x13' },
        { format: '48K', centimeter: '17x12' },
        { format: '50K', centimeter: '14.8x10.4' },
        { format: '56K', centimeter: '18x7.5' },
        { format: '64K', centimeter: '12.7x9' },
        { format: '100K', centimeter: '10x7' },
        { format: '特16K', centimeter: '23x17' },
        { format: '特28K', centimeter: '23.3x9.7' },
        { format: '特32K', centimeter: '17.2x11.5' },
        { format: '菊56K', centimeter: '13x6' }
      ]
    }
  },
  computed: {
    fields() {
      return [
        { key: 'format', label: this.$t('size-cm-conversion-table.table.header.format') },
        { key: 'centimeter', label: this.$t('size-cm-conversion-table.table.header.centimeter') }
      ]
    }
  },
  methods: {
    // 
  },
  created() {
    // 
  },
  components: {
    // 
  }  
}
</script>